import * as InputMoney from './inputMoney'

export default {
  InputMoney
}
